module.exports = __webpack_public_path__ + "static/media/vibinoLogoW.04b9c558.svg";